// extracted by css-extract-rspack-plugin
export default {"checkbox":"checkbox___i8TYwD4Q","checkbox__indicator":"checkbox__indicator___YI3Iybt9","checkbox--error":"checkbox--error___bbTup_ub"};